module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-inverted-color-scheme",
    attrs: {
      "id": "gv-legend"
    }
  }, [_vm._c('div', {
    staticClass: "gv-legend-title gv-color-scheme",
    attrs: {
      "id": "gv-legend-title"
    }
  }, [_vm._c('b', [_vm._v("LEGENDA")]), _vm._v(" "), _vm._c('button', {
    class: _vm.toggleCollapseClass(),
    attrs: {
      "size": "mini",
      "title": "Nascondi Legenda"
    },
    on: {
      "click": _vm.hideLegend
    }
  }), _vm._v(" "), _vm._c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.options.showAddMap),
      expression: "options.showAddMap"
    }],
    staticClass: "gv-color-scheme gv-legend-buttons ms ms-layers-add",
    attrs: {
      "id": "gv-legend-add-map",
      "title": "Aggiungi Mappe",
      "size": "mini"
    },
    on: {
      "click": _vm.addMap
    }
  }), _vm._v(" "), _vm._c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.options.showDownloadTotale),
      expression: "options.showDownloadTotale"
    }],
    staticClass: "gv-color-scheme gv-legend-buttons el-icon-download",
    attrs: {
      "id": "gv-legend-add-map",
      "title": "Download Mappe",
      "size": "mini"
    },
    on: {
      "click": _vm.downloadMaps
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-legend-title-collapsed gv-color-scheme",
    attrs: {
      "id": "gv-legend-title-collapsed"
    }
  }, [_vm._c('button', {
    class: _vm.toggleCollapseClass(),
    attrs: {
      "size": "mini",
      "title": "Mostra Legenda"
    },
    on: {
      "click": _vm.hideLegend
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-legend-wrapper",
    attrs: {
      "id": "gv-legend-wrapper"
    }
  }, [_vm._c('gv-legend-maps', {
    attrs: {
      "maps": _vm.maps,
      "options": _vm.options
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-legend-footer gv-inverted-color-scheme"
  }, [(_vm.options.showBaseLayerSwitcher) ? _vm._c('gv-base-layer-switcher', {
    ref: "gv-base-layer-switcher"
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-209a63b9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Legend.vue
// module id = 832
// module chunks = 39